<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-form inline :model="queryParams">
          <el-form-item style="margin-bottom: 0;">
            <el-select v-model="queryParams.position" placeholder="轮播图位置" clearable>
              <el-option v-for="(item, index) in position" :key="index" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-select v-model="queryParams.status" placeholder="状态" clearable>
              <el-option label="已禁用" value="0" />
              <el-option label="已启用" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-button type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button style="margin-left: 10px;" type="danger" icon="el-icon-edit" @click="handleCreate">新增轮播图</el-button>
          </el-form-item>
        </el-form>
      </template>

      <el-table v-sticky-header fit highlight-current-row border :data="list" header-cell-class-name="table-header-cell style1">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell style1">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="轮播图位置" prop="bannerPosition" width="120">
          <template slot-scope="{ row }">
            <el-tag :type="row.bannerPosition | positionTag" effect="dark">{{ row.bannerPosition | positionName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="轮播图图片" prop="cover" width="100" align="center" class-name="image-col">
          <template slot-scope="{row}">
            <el-image :src="row.cover" :preview-src-list="[row.cover]" lazy />
          </template>
        </el-table-column>
        <el-table-column label="背景颜色" prop="backgroundColor" width="80" class-name="name-col">
          <template slot-scope="{ row }">
            <span class="span-color" :style="{ backgroundColor: row.backgroundColor }" />
          </template>
        </el-table-column>
        <el-table-column label="跳转路径" prop="redirectTo" class-name="name-col">
          <template slot-scope="{ row }">{{ getAppMenuName(row.redirectTo) }}</template>
        </el-table-column>
        <el-table-column label="排序" prop="sortBy" align="center" width="60" />
        <el-table-column label="状态" prop="status" width="80" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row)" />
          </template>
        </el-table-column>

        <el-table-column align="center" width="80" fixed="right">
          <template slot-scope="{row}">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleEdit(row)"><i class="el-icon-edit" /> 修改轮播图</el-dropdown-item>
                <el-dropdown-item divided @click.native="handleRemove(row)"><i class="el-icon-delete" /> 删除轮播图</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="loadData" />
    </el-card>

    <el-dialog title="编辑轮播图" width="750px" :visible.sync="dialogVisible" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
      <el-form ref="detailForm" :model="detail" :rules="rules" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item label="轮播图位置" class="inline-form-item">
              <el-select v-model="detail.bannerPosition" placeholder="请选择轮播图位置">
                <el-option v-for="(item, index) in position" :key="index" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="4">
            <el-form-item label="背景颜色" class="inline-form-item">
              <el-color-picker v-model="detail.backgroundColor" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="8">
            <el-form-item label="排序" class="inline-form-item">
              <el-input v-model="detail.sortBy" placeholder="请输入排序" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item label="轮播图" prop="cover">
              <div class="image-uploader">
                <el-upload
                  action="#"
                  accept="image/*"
                  class="avatar-uploader"
                  :show-file-list="false"
                  :on-change="imageChange"
                  :http-request="imageUpload"
                >
                  <template v-if="coverImage && coverImage.url">
                    <img :src="coverImage.url" class="avatar">
                    <div class="el-upload-img-actions">
                      <span class="el-upload-img-preview" @click.stop="imagePreview">
                        <i class="el-icon-zoom-in" />
                      </span>
                      <span class="el-upload-img-delete" @click.stop="imageBeforeRemove">
                        <i class="el-icon-delete" />
                      </span>
                    </div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
                <el-image ref="elImage" style="width: 0; height: 0;" :src="coverImage.url" :preview-src-list="[coverImage.url]" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="状态" prop="status" class="inline-form-item">
              <el-switch v-model="detail.status" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="跳转路径" prop="redirectTo" class="inline-form-item">
              <el-select v-model="detail.redirectTo" placeholder="请选择跳转路径" clearable>
                <el-option v-for="(item, index) in appMenus" :key="index" :label="item.menuName" :value="item.menuLink">
                  <span style="float: left;">{{ item.menuName }}</span>
                  <span style="float: right;">{{ item.menuLink }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { uploadFile } from '@/api/oss'
import { getAllAppMenu } from '@/api/system'
import { StickyHeader } from '@cell-x/el-table-sticky'
import { getBannerPages, submitBanner, updateBanner, deleteBanner } from '@/api/article'

const BANNER_POSITION = [
  { id: 1, name: '小程序首页', type: '' },
  { id: 2, name: '优品商城首页', type: 'success' },
  { id: 3, name: '福利商城首页', type: 'info' },
  { id: 4, name: '本地商家首页', type: 'danger' }
]

export default {
  name: 'ArticleBanner',
  components: {
    Pagination: () => import('@/components/Pagination')
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  filters: {
    positionTag(id) {
      const index = BANNER_POSITION.findIndex(item => item.id === id)
      return BANNER_POSITION[index].type
    },
    positionName(id) {
      const index = BANNER_POSITION.findIndex(item => item.id === id)
      return BANNER_POSITION[index].name
    }
  },
  data() {
    this.position = BANNER_POSITION
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        page: 1,
        limit: 20,
        status: undefined,
        position: undefined
      },
      appMenus: [],
      detail: {},
      dialogVisible: false,
      coverImage: { url: '', file: null },
      rules: {}
    }
  },
  computed: mapGetters(['device']),
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([getAllAppMenu(), getBannerPages(this.queryParams)]).then(([menus, banners]) => {
        this.appMenus = menus
        this.total = banners.total
        this.list = banners.records
      }).finally(() => { this.$util.delay(500).then(() => { this.loading = false }) })
    },
    getAppMenuName(url) {
      const index = this.appMenus.findIndex(item => item.menuLink === url)
      return index >= 0 ? `${this.appMenus[index].menuName}（${this.appMenus[index].menuLink}）` : url
    },
    loadData() {
      this.loading = true
      getBannerPages(this.queryParams).then(response => {
        this.total = response.total
        this.list = response.records
      }).finally(() => { this.$util.delay(500).then(() => { this.loading = false }) })
    },
    handleFilter() {
      this.queryParams.page = 1
      this.loadData()
    },
    handleCreate() {
      this.detail = Object.assign({}, {
        status: 1,
        id: undefined,
        title: undefined,
        cover: undefined,
        bannerPosition: 2,
        redirectTo: undefined,
        backgroundColor: undefined,
        sortBy: this.total + 1
      })
      this.coverImage = { url: '', file: null }
      this.dialogVisible = true
    },
    handleEdit(item) {
      this.coverImage = Object.assign({}, { url: item.cover, file: null })
      this.detail = Object.assign({}, item)
      this.dialogVisible = true
    },
    handleRemove(item) {
      this.$confirm(`确定要删除该轮播图吗？`, '删除提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteBanner(item.id).then(response => {
          if (response) {
            const index = this.list.findIndex(aa => aa.id === item.id)
            if (index >= 0) {
              this.list.splice(index, 1)
              this.total--
            }
          }
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          setTimeout(() => { this.loading = false }, 500)
        })
      })
    },
    handleUpdate(item) {
      updateBanner(item).catch(() => {})
    },
    dialogClose() {
      this.dialogVisible = false
    },
    onSubmit() {
      this.$refs.detailForm.validate(valid => {
        if (!valid) return false

        this.loading = true
        // 上传商品图片
        this.uploadImages().then(() => {
          this.detail.cover = this.coverImage.url
          return submitBanner(this.detail)
        }).then(response => {
          this.detail = response
          this.$util.delay(500).then(() => {
            const index = this.list.findIndex(item => item.id === response.id)
            if (index >= 0) {
              this.list.splice(index, 1, response)
            } else {
              this.list.push(response)
              this.total++
            }

            this.loading = false
            this.dialogVisible = false
            this.$message.success('轮播图提交保存成功')
          })
        }).catch(() => {})
      })
    },
    uploadImages() {
      return new Promise((resolve, reject) => {
        if (this.coverImage.file) {
          uploadFile(this.coverImage.file).then(response => {
            this.coverImage = Object.assign({}, { url: response, file: null })
            resolve()
          }).catch(() => reject('图片上传失败'))
        } else {
          resolve()
        }
      })
    },
    imageChange(file) {
      if (!file) return false

      const isImage = `${file.raw.type}`.startsWith('image/')
      if (!isImage) return this.$message.warning('上传的文件必须是图片')

      this.coverImage.url = URL.createObjectURL(file.raw)
    },
    imageUpload(form) {
      const formData = new FormData()
      formData.append('file', form.file)
      formData.append('name', form.file.name)
      formData.append('fileSize', form.file.size)
      formData.append('fileType', form.file.type)

      this.coverImage.file = formData
    },
    imagePreview() {
      this.$nextTick(() => this.$refs.elImage.clickHandler())
    },
    imageBeforeRemove() {
      this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' }).then(() => {
        this.coverImage = Object.assign({}, { url: undefined, file: null })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.span-color {
  width: 100%;
  height: 30px;
  display: block;
  border-radius: 3px;
}
.image-uploader {
  .avatar-uploader::v-deep {
    .el-upload {
      width: 100%;
      min-height: 100px;
    }
  }
}
</style>
